export function FontSegoe({ children }) {
  return <span className={"font-segoe"}>{children}</span>;
}
